module.exports = __webpack_public_path__ + "static/img/business_chair_h2_l.a8dc138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/business_chair_h2_l.png
// module id = dGqD
// module chunks = 3